/**
 * People API Hook
 * React hook for fetching data from the People API
 */

import { useCallback } from 'react'
import { useApi } from '@/lib/api'
import { type T4SalariedDetailsResponse, type EngagementDetailsResponse } from '@/types/api/people'

export function usePeopleApi() {
  const { peopleApi } = useApi()

  const fetchT4SalariedDetails = useCallback(async (userProfileId: number): Promise<T4SalariedDetailsResponse> => {
    const endpoint = `People/${userProfileId}/t4-salaried-details`
    const response = await peopleApi.get<T4SalariedDetailsResponse>(endpoint)
    
    return response
  }, [peopleApi])

  const fetchEngagementDetails = useCallback(async (userProfileId: number): Promise<EngagementDetailsResponse> => {
    const endpoint = `People/${userProfileId}/engagement-details`
    const response = await peopleApi.get<EngagementDetailsResponse>(endpoint)
    return response
  }, [peopleApi])

  return {
    fetchT4SalariedDetails,
    fetchEngagementDetails
  }
} 